import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  tableCellClasses,
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import React from 'react';

import { DesignToken } from '~/client/components/base/core';

const StyledTableCell = muiStyled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: DesignToken.surface2,
    color: DesignToken.textPrimary,
    fontSize: '14px',
    fontWeight: 600,
    padding: '16px 12px',
    borderBottom: `1px solid ${DesignToken.borderSubtle}`,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '16px 12px',
    borderBottom: `1px solid ${DesignToken.surface2}`,
  },
}));

/**
 * Table-only skeleton for ANCH use cases (no Card wrapper).
 * Used inside ProjectTable's alternate tab content during loading.
 */
const AnchUseCasesContentSkeleton: React.FC = () => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <StyledTableCell align="left">
            <Skeleton width={60} height={20} />
          </StyledTableCell>
          <StyledTableCell align="center">
            <Skeleton width={60} height={20} />
          </StyledTableCell>
          <StyledTableCell align="center">
            <Skeleton width={80} height={20} />
          </StyledTableCell>
          <StyledTableCell align="center">
            <Skeleton width={70} height={20} />
          </StyledTableCell>
          <StyledTableCell align="center">
            <Skeleton width={60} height={20} />
          </StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[1, 2, 3, 4, 5].map((idx) => (
          <TableRow key={idx}>
            <StyledTableCell>
              <Skeleton width="80%" height={24} />
            </StyledTableCell>
            <StyledTableCell align="center">
              <Skeleton
                variant="rounded"
                width={80}
                height={24}
                sx={{ margin: '0 auto' }}
              />
            </StyledTableCell>
            <StyledTableCell align="center">
              <Skeleton width={30} height={24} sx={{ margin: '0 auto' }} />
            </StyledTableCell>
            <StyledTableCell align="center">
              <Skeleton
                variant="rounded"
                width={100}
                height={20}
                sx={{ margin: '0 auto' }}
              />
            </StyledTableCell>
            <StyledTableCell align="center">
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ margin: '0 auto' }}
              />
            </StyledTableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default AnchUseCasesContentSkeleton;
